export default __webpack_public_path__ + "static/media/purpple-vaccine-lg.26e07662.svg";